import {
  Button,
  ButtonGroup,
  Popover,
  PopoverTrigger,
  Portal,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  PopoverFooter,
  Text,
  useDisclosure,
} from '@chakra-ui/core';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../../models/hooks';
import { isSectionSchema } from '../utils';

const ClearAll = React.memo(function ClearAllTemplateComponent() {
  const { t } = useTranslation('hrFormTemplate');
  const { onOpen, onClose, isOpen } = useDisclosure();

  const { formSchema, isUpdating, isLoading } = useStoreState((state) => state.formBuilder);
  const { setSchema, setErrors } = useStoreActions((actions) => actions.formBuilder);

  const handleClearAll = useCallback(() => {
    setSchema([]);
    setErrors([]);
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setErrors]);

  const isButtonDisabled = useMemo(() => {
    const isInitialEmptySchema =
      formSchema.length === 1 &&
      formSchema[0]?.id &&
      isSectionSchema(formSchema[0]) &&
      formSchema[0]?.section === 'section1' &&
      formSchema[0]?.fields?.length === 0;

    return formSchema.length === 0 || isInitialEmptySchema || isUpdating || isLoading;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formSchema, isUpdating, isLoading]);

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} closeOnBlur closeOnEsc isLazy>
      <PopoverTrigger>
        <Button
          colorScheme="red"
          size="sm"
          variant="outline"
          isDisabled={isButtonDisabled}
          data-testid="clear-all-button"
          minW="auto"
        >
          {t('formBuilder.clearAll')}
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody py={4}>
            <Text>{t('formBuilder.clearAllPopoverMessage')}</Text>
          </PopoverBody>
          <PopoverFooter display="flex" justifyContent="flex-end" borderTopWidth="1px" p={3}>
            <ButtonGroup size="sm">
              <Button variant="outline" onClick={onClose} ref={undefined}>
                {t('formBuilder.no')}
              </Button>
              <Button colorScheme="red" onClick={handleClearAll}>
                {t('formBuilder.yes')}
              </Button>
            </ButtonGroup>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
});

export default ClearAll;
